module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNC43MyAyNy40NiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwMDA7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8xLTIiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0ibTE0LjQ0LDE0LjQ0TDEuNzEsMjcuMTdjLS4yLjItLjQ1LjI5LS43MS4yOXMtLjUxLS4xLS43MS0uMjljLS4zOS0uMzktLjM5LTEuMDIsMC0xLjQxbDEyLjAyLTEyLjAyTC4yOSwxLjcxQy0uMSwxLjMyLS4xLjY4LjI5LjI5UzEuMzItLjEsMS43MS4yOWwxMi43MywxMi43M2MuMzkuMzkuMzksMS4wMiwwLDEuNDFaIi8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accounting/arrow_right_promo_black.svg
// module id = JbZP
// module chunks = 13